<template>
  <div style="position: relative">
    <swiper
      class="swiper SupportedBySwiper"
      ref="SupportedBy"
      :options="swiperOptions"
    >
      <slot name="slides"></slot>
    </swiper>
      <slot name="pagination"></slot>
    <slot name="navigation"></slot>
  </div>
</template>
<script>
import { swiper } from "vue-awesome-swiper";
import 'swiper/css/swiper.css'
export default {
  name: "SwiperX",
  props: {
    swiperOptions: {
      type: Object,
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  components: {
    swiper,
  },
  computed: {
    swiper() {
      return this.$refs.SupportedBy.swiper;
    },
  },
  mounted() {
    this.swiper.on("slideChange", () => {
      this.swiper.slideTo(this.swiper.activeIndex, 300, false);
      this.$emit("slide-index-change", this.swiper.activeIndex);
      this.updatePagination();
    });
  },
  methods: {
    updatePagination() {
      // 获取当前活动的 slide 索引
      const activeIndex = this.$refs.SupportedBy.swiper.activeIndex;
      // 遍历所有圆点，根据当前活动的 slide 更新活动状态
      const dots = this.$el.querySelectorAll(".swiper-pagination-bullet");
      dots.forEach((dot, index) => {
        dot.classList.toggle(
          "swiper-pagination-bullet-active",
          index === activeIndex
        );
      });
    },
  },
};
</script>